export class CalendarConfiguration {
  perSlotCount: number | null;
  slotDurationInMinutes: number | null;
  reservationTimeInMinutes: number | null;
  idlePeriod: number | null;
  maxAvailableDays: number | null;
  serviceId: string | null;
  businessId: string | null;
  staffId: string | null;
  timeZone: string | null;

  constructor(
    perSlotCount: number | null,
    slotDurationInMinutes: number | null,
    reservationTimeInMinutes: number | null,
    idlePeriod: number | null,
    maxAvailableDays: number | null,
    serviceId: string | null,
    businessId: string | null,
    staffId: string | null,
    timeZone: string | null
  ) {
    this.perSlotCount = perSlotCount;
    this.slotDurationInMinutes = slotDurationInMinutes;
    this.reservationTimeInMinutes = reservationTimeInMinutes;
    this.idlePeriod = idlePeriod;
    this.maxAvailableDays = maxAvailableDays;
    this.serviceId = serviceId;
    this.businessId = businessId;
    this.staffId = staffId;
    this.timeZone = timeZone;
  }
}
